const token = localStorage.getItem('token') || '';
import env from '../enviroments/enviroment';

const getOrderFileReq = async (id: number, params: any) => {
  const response = await fetch(
    `${env.base_url}/orders/file/${id}?${new URLSearchParams(params)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return {blob: await response.blob(), ok: response.ok};
};

export default getOrderFileReq;
